import { Component, OnInit, Input } from '@angular/core';
import { ToastService } from 'src/app/shared/foundation/toast/toast.service';
import { TranslationMessagesPipe } from 'src/app/shared/pipes/translation-msg.pipe';
import { ValidatorMessageModel } from '../../form/form-helpers/validation/validator-message.model';
import { SelectedBuildingModel } from 'src/app/views/components/utils/selected-building.model';
import { SelectedParcelModel } from 'src/app/views/components/utils/selected-parcel.model';
import { SelectedItemUtil } from 'src/app/views/components/utils/selected-item.utils';
import { DamageTo } from 'src/app/views/claim/components/forms/models/damage-to.enum';

@Component({
  selector: 'app-selected-items',
  templateUrl: './selected-items.component.html',
  styleUrls: ['./selected-items.component.scss'],
})
export class SelectedItemsComponent implements OnInit {
  @Input() itemType: DamageTo;
  @Input() validatorMessage?: string;
  @Input() itemAlreadyAddedMessage?: string;
  @Input() invalidSelectionMessage?: string;
  selectedItems: Array<SelectedBuildingModel | SelectedParcelModel> = [];

  wasValidated = false;

  constructor(
    private selectedItemUtil: SelectedItemUtil,
    private toastService: ToastService,
    private msgPipe: TranslationMessagesPipe
  ) {}

  ngOnInit(): void {
    this.resetItems();
  }

  addItem(item: SelectedBuildingModel | SelectedParcelModel): void {
    if (item.type === DamageTo.BUILDING) {
      let found = this.selectedItems.find(
        (b) =>
          (item as SelectedBuildingModel).building.buildingNumber ===
          (b as SelectedBuildingModel).building.buildingNumber
      );

      if (found) {
        this.toastService.showWarningToast(
          this.msgPipe.transformInstant(
            this.itemAlreadyAddedMessage
              ? this.itemAlreadyAddedMessage
              : 'toasts.itemAlreadyAdded'
          ),
          1000
        );
        return;
      } else {
        this.selectedItems.push(item);
        this.selectedItemUtil.selectedBuildings = this
          .selectedItems as Array<SelectedBuildingModel>;
      }
    }

    if (item.type === DamageTo.PROPERTY) {
      let found = this.selectedItems.find(
        (p) =>
          (item as SelectedParcelModel).parcel.parcelNumber ===
          (p as SelectedParcelModel).parcel.parcelNumber
      );

      if (found) {
        this.toastService.showWarningToast(
          this.msgPipe.transformInstant(
            this.itemAlreadyAddedMessage
              ? this.itemAlreadyAddedMessage
              : 'toasts.itemAlreadyAdded'
          ),
          1000
        );
        return;
      } else {
        if (this.selectedItems.length === 0) {
          this.selectedItems.push(item);
          this.selectedItemUtil.selectedParcel = item as SelectedParcelModel;
        }
      }
    }
  }

  removeItem(
    index: number,
    item: SelectedBuildingModel | SelectedParcelModel
  ): void {
    this.selectedItems?.splice(index, 1);
    this.selectedItemUtil.removeItem(item);
  }

  resetItems(): void {
    // this.items = [];
  }

  getSelectedItems(): Array<any> {
    return [''];
    // return this.items!;
  }

  getSelectedIdentifiers(byExternal = false): Array<string> {
    // return this.items?.map(function (item) {
    //   if (!byExternal) {
    //     return item['identifier'];
    //   } else {
    //     return item['externalNumber'];
    //   }
    // })!;
    return [''];
  }

  trigger(): void {
    this.wasValidated = true;
  }

  checkIfValid(): boolean {
    if (Array.isArray(this.selectedItems)) {
      return this.selectedItems?.length != 0;
    } else {
      return this.selectedItems != null;
    }
  }

  getValidationMessages(): ValidatorMessageModel[] | null {
    const errorsMessages: ValidatorMessageModel[] = [];
    if (
      !this.selectedItems ||
      (this.selectedItems as Array<SelectedBuildingModel>).length == 0
    ) {
      errorsMessages.push(
        new ValidatorMessageModel(
          this.validatorMessage
            ? this.validatorMessage
            : 'validators.selectItem'
        )
      );

      return errorsMessages;
    }
    return null;
  }

  getItemDisplay(item: SelectedBuildingModel | SelectedParcelModel): string {
    return this.selectedItemUtil.formatAddress(item);
  }
}
